import { Box, Flex, Text, AspectRatio } from '@chakra-ui/react'
import Image from 'next/image'
import { COLOR } from './'

const Title: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className
}) => {
  return (
    <Text
      className={className}
      color={COLOR.LIGHT}
      fontSize={{ base: 'md', md: 'lg' }}
    >
      {children}
    </Text>
  )
}

const Subtitle: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className
}) => {
  return (
    <Text
      className={className}
      color={COLOR.YELLOW}
      fontWeight="bold"
      fontSize={{ base: 'sm', md: 'md' }}
    >
      {children}
    </Text>
  )
}

const Result = () => {
  return (
    <Box className="py-12">
      <Flex
        direction="column"
        alignItems="center"
        gap={{ base: '40px', md: '80px' }}
      >
        <Flex justifyContent="center" alignItems="center">
          <Box w={{ base: '280px', sm: '320px', md: '500px' }} h="100%">
            <AspectRatio ratio={99 / 31} w="100%" position="relative">
              <Image
                src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/Screenshot_2025-01-19_at_4.27.36_PM-removebg-preview-1737272815969-transformed-1737600163134.png"
                alt="product name"
                fill
              />
            </AspectRatio>
          </Box>
        </Flex>

        <Flex direction="column" gap={{ base: '40px', md: '80px' }}>
          <Flex
            direction={{ base: 'column', md: 'row' }}
            gap={{ base: '40px', lg: '80px' }}
            alignItems="center"
          >
            <Box w={{ base: '100%', md: '50%' }}>
              <Title className="mb-1">TESTIMONIAL</Title>
              <Subtitle className="mb-4">
                (*Nai Ge personally witnessesd)
              </Subtitle>

              <Text color={COLOR.LIGHT} fontWeight="bold">
                While visiting his son in the U.S., Xu Nailin experienced a drop
                in immunity due to the long journey. Just two days after his
                arrival, a painful bump appeared on the upper right side of his
                scalp, which eventually turned into a pus-filled wound. Unable
                to seek medical treatment abroad, he had no choice but to let it
                heal naturally. Upon returning to Taiwan, Xu was distressed to
                find a bald spot where the wound had been. Known for maintaining
                a polished appearance throughout his career, this unexpected
                hair loss left him feeling anxious. Though he tried to reassure
                himself by saying, “At least I can cover it with my remaining
                hair,” he couldn’t ignore his concerns. With a family history of
                fine, soft hair, the baldness was particularly worrying.
                Fortunately, Xu discovered a biotech company that offered an
                effective solution. Their product not only helped restore his
                hair but also his confidence. Grateful for the transformation,
                Xu became the proud spokesperson for the brand, sharing his
                story to inspire others.
              </Text>
            </Box>
            <Box w={{ base: '100%', md: '50%' }}>
              <Flex direction="column" gap="48px">
                <Box>
                  <Text
                    color={COLOR.LIGHT}
                    mb="8px"
                    fontSize={{ base: 'md', md: 'lg' }}
                    className="uppercase"
                  >
                    Before
                  </Text>
                  <Flex gap="32px" justify="center">
                    <Box
                      w="30%"
                      h={{ base: '160px', lg: '240px' }}
                      className="rounded-lg overflow-hidden"
                    >
                      <Image
                        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a1-1739415672852.png"
                        width={200}
                        height={360}
                        alt="result"
                        className="w-full h-full object-cover"
                      />
                    </Box>
                    <Box
                      w="30%"
                      h={{ base: '160px', lg: '240px' }}
                      className="rounded-lg overflow-hidden"
                    >
                      <Image
                        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a2-1739415672854.png"
                        width={200}
                        height={360}
                        alt="result"
                        className="w-full h-full object-cover"
                      />
                    </Box>
                    <Box
                      w="30%"
                      h={{ base: '160px', lg: '240px' }}
                      className="rounded-lg overflow-hidden"
                    >
                      <Image
                        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a3-1739415672854.png"
                        width={200}
                        height={360}
                        alt="result"
                        className="w-full h-full object-cover"
                      />
                    </Box>
                  </Flex>
                </Box>
                <Box>
                  <Text
                    color={COLOR.LIGHT}
                    mb="8px"
                    fontSize={{ base: 'md', md: 'lg' }}
                    className="uppercase"
                  >
                    After
                  </Text>
                  <Flex gap="32px" justify="center">
                    <Box
                      w="30%"
                      h={{ base: '160px', lg: '240px' }}
                      className="rounded-lg overflow-hidden"
                    >
                      <Image
                        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a4-1739415672855.png"
                        width={200}
                        height={360}
                        alt="result"
                        className="w-full h-full object-cover"
                      />
                    </Box>
                    <Box
                      w="30%"
                      h={{ base: '160px', lg: '240px' }}
                      className="rounded-lg overflow-hidden"
                    >
                      <Image
                        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a5-1739415672855.png"
                        width={200}
                        height={360}
                        alt="result"
                        className="w-full h-full object-cover"
                      />
                    </Box>
                    <Box
                      w="30%"
                      h={{ base: '160px', lg: '240px' }}
                      className="rounded-lg overflow-hidden"
                    >
                      <Image
                        src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/a6-1739415672857.png"
                        width={200}
                        height={360}
                        alt="result"
                        className="w-full h-full object-cover"
                      />
                    </Box>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Flex>

          <Flex
            direction={{ base: 'column-reverse', md: 'row' }}
            justifyContent="space-between"
            alignItems="center"
            gap={{ base: '40px', lg: '80px' }}
          >
            <Flex w={{ base: '100%', md: '50%' }} h="100%" className="gap-8">
              <Box className="md:w-[280px] w-full h-full">
                <AspectRatio w="100%" position="relative" ratio={462 / 660}>
                  <Image
                    src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/b1-1739416458294.png"
                    alt="result"
                    fill
                  />
                </AspectRatio>
              </Box>
              <Box className="md:w-[280px] w-full h-full">
                <AspectRatio w="100%" position="relative" ratio={462 / 660}>
                  <Image
                    src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/b2-1739416458294.png"
                    alt="result"
                    fill
                  />
                </AspectRatio>
              </Box>
            </Flex>

            <Box
              w={{ base: '100%', md: '50%' }}
              textAlign={{ base: 'left', md: 'right' }}
            >
              <Subtitle className="mb-1">Case: Female (35 years old)</Subtitle>
              <Subtitle className="mb-4">
                Case of hairloss: Postpartum hairloss
              </Subtitle>
              <Text color={COLOR.LIGHT}>
                Experienced the luminous product for 55 days, before (left) and
                after (right) comparison pictures.
              </Text>
            </Box>
          </Flex>

          <Flex
            direction={{ base: 'column', md: 'row' }}
            justifyContent="space-between"
            alignItems="center"
            gap={{ base: '40px', md: '80px' }}
          >
            <Box w={{ base: '100%', md: '50%' }}>
              <Subtitle className="mb-1">Case: Female (62 years old)</Subtitle>
              <Subtitle className="mb-4">
                Case of hairloss: Menapause hairloss
              </Subtitle>
              <Text color={COLOR.LIGHT}>
                Experienced the luminous product for 90 days, before (left) and
                after (right) comparison pictures.
              </Text>
            </Box>

            <Box className="w-full h-full">
              <AspectRatio w="100%" position="relative" ratio={627 / 244}>
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/t1-1737466466468.jpg"
                  alt="result"
                  fill
                />
              </AspectRatio>
            </Box>
          </Flex>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Result
